import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=cb331628&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=cb331628&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb331628",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb331628')) {
      api.createRecord('cb331628', component.options)
    } else {
      api.reload('cb331628', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=cb331628&scoped=true&", function () {
      api.rerender('cb331628', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qT8cvzCv2rt0/JS/comp/Voucher.vue"
export default component.exports